module.exports = __webpack_public_path__ + "8ed37cf16b2229e9837761fe24621316.svg";